define('RecipesAndEvents.KitCart.Confirmation.View', [
    'Backbone.CompositeView',
    'kit_cart_confirmation_modal.tpl',
    'Backbone',
    'underscore'
], function RecipesAndEventsKitCartConfirmationView(
    BackboneCompositeView,
    kitCartConfirmationModalTpl,
    Backbone,
    _
) {
    'use strict';

    return Backbone.View.extend({
        template: kitCartConfirmationModalTpl,
        title: _('Added to Cart').translate(),
        modalClass: 'global-views-modal-large',
        page_header: _('Added to Cart').translate(),
        attributes: {
            'id': 'shopping-cart',
            'class': 'add-to-cart-confirmation-modal shopping-cart-modal'
        },
        events: {
            'click [data-trigger=go-to-cart]': 'dismisAndGoToCart'
        },
        initialize: function initialize(options) {
            this.model = options.model;
            this.ingredients = options.ingredients;
            BackboneCompositeView.add(this);
        },
        dismisAndGoToCart: function dismisAndGoToCart(e) {
            e.preventDefault();
            this.$containerModal.modal('hide');
            this.options.layout.goToCart();
        },
        getContext: function getContext() {
            return {
                image_url: this.model &&
                    this.model.get('item') &&
                    this.model.get('item').get('_images') ? this.model.get('item').get('_images')[0].url : '',
                line: this.model,
                recipe_name: this.model && this.model.get('item') && this.model.get('item').get('_name'),
                ingredients: this.ingredients
            };
        }
    });
});
